import { Card, Grid, IconButton, Box, CircularProgress, Paper, Typography, useMediaQuery, useTheme } from "@mui/material"
import MonetizationOnIcon from '@mui/icons-material/MonetizationOn';
import PeopleIcon from '@mui/icons-material/People';
import WalletIcon from '@mui/icons-material/Wallet';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import TrendingUpIcon from '@mui/icons-material/TrendingUp';
import PaymentsIcon from '@mui/icons-material/Payments';
import AddCardIcon from '@mui/icons-material/AddCard';
import RemoveCircleOutlineIcon from '@mui/icons-material/RemoveCircleOutline';
import SwapHorizIcon from '@mui/icons-material/SwapHoriz';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';

import { useEffect, useState } from "react";
import axios from "../api/axios"
import useAuth from '../hooks/useAuth';
import ReactApexChart from 'react-apexcharts';

import "../css/Escritorio.css"


export default function Escritorio(props) {
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [disponible, setDisponible] = useState("0.00")
    const [invertido, setInvertido] = useState("0.00")
    const [ganancias, setGanancias] = useState("0.00")
    const [transito, setTransito] = useState("0.00")
    const [fechaGanancia, setFechaGanancia] = useState("")
    const [cobradoCapital, setCobradoCapital] = useState("0.00")
    const [clientes, setClientes] = useState("0")
    const [atrasados, setAtrasados] = useState("0")
    const [montoAtrasados, setMontoAtrasados] = useState("0.00")
    const [montoClientesAlDia, setMontoClientesAlDia] = useState("0.00")
    const { auth } = useAuth();
    const [cargando, setCargando] = useState(true)
    const [movimientos, setMovimientos] = useState([])
    const [totalDisponible, setTotalDisponible] = useState(0)
    const [totalGanancias, setTotalGanancias] = useState(0)
    const [cantidadMovimientos, setCantidadMovimientos] = useState(0)

    // Estados para resumen histórico
    const [histFechaPrimerMov, setHistFechaPrimerMov] = useState("")
    const [fechaPrimerDeposito, setFechaPrimerDeposito] = useState(null) // Fecha real del primer depósito para filtrar

    // Estados para sumatorias por tipo
    const [histNetoIntereses, setHistNetoIntereses] = useState("0.00")
    const [histRetiroGanancias, setHistRetiroGanancias] = useState("0.00")
    const [histRetiroDisponible, setHistRetiroDisponible] = useState("0.00")
    const [histDepositos, setHistDepositos] = useState("0.00")
    const [histGananciaADisponibilidad, setHistGananciaADisponibilidad] = useState("0.00")
    const [histTotalRetiros, setHistTotalRetiros] = useState("0.00")
    const [chartData, setChartData] = useState({
        series: [{
            name: 'Disponible',
            data: []
        }, {
            name: 'Ganancias',
            data: []
        }],
        options: {
            chart: {
                type: 'area',
                height: 350,
                toolbar: {
                    show: true,
                    offsetX: 0,
                    offsetY: 0,
                    tools: {
                        download: true,
                        selection: false,
                        zoom: true,
                        zoomin: true,
                        zoomout: true,
                        pan: false,
                        reset: true
                    },
                },
                zoom: { enabled: true }
            },
            colors: ['#1e3a5f', '#d4af37'],
            dataLabels: { enabled: false },
            stroke: { curve: 'smooth', width: 2 },
            fill: {
                type: 'gradient',
                gradient: {
                    shadeIntensity: 1,
                    opacityFrom: 0.4,
                    opacityTo: 0.1,
                    stops: [0, 90, 100]
                }
            },
            xaxis: {
                type: 'category',
                categories: [],
                labels: { rotate: -45 }
            },
            yaxis: {
                labels: {
                    formatter: function (val) {
                        return val.toLocaleString('en-US', { minimumFractionDigits: 2 });
                    }
                }
            },
            tooltip: {
                y: {
                    formatter: function (val) {
                        return "RD$ " + val.toLocaleString('en-US', { minimumFractionDigits: 2 });
                    }
                }
            },
            legend: { position: 'top' },
            title: {
                text: 'Movimientos del Mes',
                align: 'center',
                style: { fontSize: '16px', color: '#1e3a5f' }
            }
        }
    })


    useEffect(() => {
        actDatos();
        actResumenHistorico(); // Primero obtener fecha del primer depósito
        actMontoAtrasados(); // Obtener monto de inversiones atrasadas
    }, [])

    useEffect(() => {
        actDatos();
        actResumenHistorico(); // Primero obtener fecha del primer depósito
        actMontoAtrasados(); // Obtener monto de inversiones atrasadas
    }, [auth.inversionista])

    // Ejecutar actMovimientos cuando se obtenga la fecha del primer depósito
    useEffect(() => {
        actMovimientos();
    }, [fechaPrimerDeposito])

    const getDesde = () => {
        const cual = new Date();
        var mm = cual.getMonth() + 1;
        var yyyy = cual.getFullYear();
        if (mm < 10) { mm = '0' + mm; }
        return yyyy + '-' + mm + '-01';
    }

    const getHasta = () => {
        const cual = new Date();
        var mm = cual.getMonth() + 1;
        var yyyy = cual.getFullYear();
        if (mm === 12) { mm = 1; yyyy++; } else { mm++; }
        let prox = new Date(yyyy, (mm - 1), 1);
        prox.setDate(prox.getDate() - 1);
        mm = prox.getMonth() + 1;
        yyyy = prox.getFullYear();
        let dd = prox.getDate();
        if (mm < 10) { mm = '0' + mm; }
        if (dd < 10) { dd = '0' + dd; }
        return yyyy + '-' + mm + '-' + dd;
    }

    // Función auxiliar para convertir fecha dd-MM-yyyy a Date
    const parseFechaDDMMYYYY = (fechaStr) => {
        if (!fechaStr) return null;
        const partes = fechaStr.split('-');
        if (partes.length === 3) {
            return new Date(partes[2], partes[1] - 1, partes[0]);
        }
        return null;
    }

    const actMovimientos = async () => {
        try {
            const respuesta = await axios.post("movimientos/consulta2", {
                inversionista: auth.inversionista,
                desde: getDesde(),
                hasta: getHasta()
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            const data = respuesta.data;
            if (data.respuesta === "S" && data.lista) {
                // Filtrar movimientos: solo mostrar desde el primer depósito en adelante
                let listaFiltrada = data.lista;

                if (fechaPrimerDeposito) {
                    listaFiltrada = data.lista.filter(row => {
                        const fechaMov = parseFechaDDMMYYYY(row.fecha);
                        return fechaMov && fechaMov >= fechaPrimerDeposito;
                    });
                } else {
                    // Si no hay fecha de primer depósito, filtrar registros sin movimientos reales
                    // (donde disponible y ganancia son 0 o negativos antes del primer depósito positivo)
                    const indicePrimerDeposito = data.lista.findIndex(row => parseFloat(row.disponible) > 0);
                    if (indicePrimerDeposito > 0) {
                        listaFiltrada = data.lista.slice(indicePrimerDeposito);
                    }
                }

                setMovimientos(listaFiltrada);

                const fechas = listaFiltrada.map(row => row.fecha);
                const disponibles = listaFiltrada.map(row => parseFloat(row.acum_disponible) || 0);
                const gananciasData = listaFiltrada.map(row => parseFloat(row.acum_ganancia) || 0);

                // Calcular sumatorias
                let sumDisponible = 0;
                let sumGanancias = 0;
                listaFiltrada.forEach(row => {
                    sumDisponible += parseFloat(row.disponible) || 0;
                    sumGanancias += parseFloat(row.ganancia) || 0;
                });
                setTotalDisponible(sumDisponible);
                setTotalGanancias(sumGanancias);
                setCantidadMovimientos(listaFiltrada.length);

                setChartData(prev => ({
                    ...prev,
                    series: [
                        { name: 'Disponible Acumulado', data: disponibles },
                        { name: 'Ganancias Acumuladas', data: gananciasData }
                    ],
                    options: {
                        ...prev.options,
                        xaxis: { ...prev.options.xaxis, categories: fechas }
                    }
                }));
            }
        } catch (error) {
            console.error("Error en actMovimientos:", error);
        }
    }


    const actDatos = async () => {
        setCargando(true)
        try {
            const respuesta = await axios.post("dashboard/resumen", {
                inversionista: auth.inversionista
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            const data = respuesta.data;
            if (data.respuesta == "S") {
                setFechaGanancia(data.fechaganancia)
                setDisponible(parseFloat(parseFloat(data.disponible).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
                setInvertido(parseFloat(parseFloat(data.invertido).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
                setGanancias(parseFloat(parseFloat(data.ganancia).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
                setTransito(parseFloat(parseFloat(data.transito).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
                setCobradoCapital(parseFloat(parseFloat(data.capital).toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 }))
                setClientes(data.clientes);
                setAtrasados(data.atrasados);
            }
        } catch (error) {
            console.error("Error en actDatos:", error)
        }
        setCargando(false)
    }

    // Obtener monto de inversiones atrasadas (estatus=2) y calcular clientes al día
    const actMontoAtrasados = async () => {
        try {
            // Obtener todas las inversiones (estatus=0)
            const respTodasInversiones = await axios.get("inversiones/lista?cual=" + auth.inversionista + "&estatus=0", {
                headers: { 'Content-Type': 'application/json' }
            });

            // Obtener inversiones atrasadas (estatus=2)
            const respAtrasados = await axios.get("inversiones/lista?cual=" + auth.inversionista + "&estatus=2", {
                headers: { 'Content-Type': 'application/json' }
            });

            let totalInvertido = 0;
            let totalAtrasados = 0;

            // Calcular total invertido (todas las inversiones)
            if (respTodasInversiones.data.respuesta == "S") {
                for (var i = 0; i < respTodasInversiones.data.lista.length; i++) {
                    totalInvertido += parseFloat(respTodasInversiones.data.lista[i].inversion_balance) || 0;
                }
            }

            // Calcular total atrasados
            if (respAtrasados.data.respuesta == "S") {
                for (var j = 0; j < respAtrasados.data.lista.length; j++) {
                    totalAtrasados += parseFloat(respAtrasados.data.lista[j].inversion_balance) || 0;
                }
            }

            // Calcular clientes al día (Invertido - Atrasados)
            const clientesAlDia = totalInvertido - totalAtrasados;

            setMontoAtrasados(parseFloat(totalAtrasados.toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2 }));
            setMontoClientesAlDia(parseFloat(clientesAlDia.toFixed(2)).toLocaleString('en-US', { minimumFractionDigits: 2 }));
        } catch (error) {
            console.error("Error en actMontoAtrasados:", error)
        }
    }

    const actResumenHistorico = async () => {
        try {
            // Obtener todos los movimientos históricos (desde 2020 hasta hoy)
            const respuesta = await axios.post("movimientos/consulta2", {
                inversionista: auth.inversionista,
                desde: "2020-01-01",
                hasta: new Date().toISOString().split('T')[0]
            }, {
                headers: { 'Content-Type': 'application/json' }
            });
            const data = respuesta.data;
            if (data.respuesta === "S" && data.lista && data.lista.length > 0) {
                // Buscar el índice del primer registro con depósito positivo (primer depósito real)
                const indicePrimerDeposito = data.lista.findIndex(row => parseFloat(row.disponible) > 0);

                // Si no hay depósitos, no hay datos válidos
                if (indicePrimerDeposito === -1) {
                    return;
                }

                // Filtrar lista desde el primer depósito en adelante
                const listaFiltrada = data.lista.slice(indicePrimerDeposito);
                const primerDeposito = listaFiltrada[0];

                if (primerDeposito) {
                    // Convertir fecha dd-MM-yyyy a Date para comparaciones
                    const partesFecha = primerDeposito.fecha.split('-');
                    if (partesFecha.length === 3) {
                        const fechaDeposito = new Date(partesFecha[2], partesFecha[1] - 1, partesFecha[0]);
                        setFechaPrimerDeposito(fechaDeposito);
                    }
                }

                // Calcular sumatorias directamente de los valores de cada fila
                // Igual que lo hace el módulo Consulta detallada de movimientos
                let sumDepositos = 0;          // Suma de disponible positivo
                let sumRetiroDisponible = 0;   // Suma de disponible negativo (valor absoluto)
                let sumNetoIntereses = 0;      // Suma de ganancia positiva
                let sumRetiroGanancias = 0;    // Suma de ganancia negativa (retiro ganancias)
                let sumGananciaADisponibilidad = 0; // Suma de ganancia a disponibilidad

                listaFiltrada.forEach(row => {
                    const concepto = (row.nombre || "").toLowerCase();
                    const disponible = parseFloat(row.disponible) || 0;
                    const ganancia = parseFloat(row.ganancia) || 0;

                    // Depósitos: solo conceptos que contengan "depósito" o "deposito"
                    if (concepto.includes('depósito') || concepto.includes('deposito')) {
                        if (disponible > 0) {
                            sumDepositos += disponible;
                        }
                    }

                    // Retiro de disponible: conceptos de retiro con disponible negativo
                    if (concepto.includes('retiro') && disponible < 0) {
                        sumRetiroDisponible += Math.abs(disponible);
                    }

                    // Neto intereses cobrados: solo conceptos que contengan "neto intereses" o "intereses cobrados"
                    if (concepto.includes('neto intereses') || concepto.includes('intereses cobrados')) {
                        if (ganancia > 0) {
                            sumNetoIntereses += ganancia;
                        }
                    }

                    // Retiro de ganancias: solo conceptos "retiro ganancias"
                    if (concepto.includes('retiro ganancias') || concepto.includes('retiro de ganancias')) {
                        if (ganancia < 0) {
                            sumRetiroGanancias += Math.abs(ganancia);
                        }
                    }

                    // Ganancia a disponibilidad: transferencia de ganancias a disponibilidad
                    if (concepto.includes('ganancia a disponibilidad')) {
                        if (ganancia < 0) {
                            sumGananciaADisponibilidad += Math.abs(ganancia);
                        }
                    }
                });

                setHistDepositos(sumDepositos.toLocaleString('en-US', { minimumFractionDigits: 2 }));
                setHistNetoIntereses(sumNetoIntereses.toLocaleString('en-US', { minimumFractionDigits: 2 }));
                setHistRetiroGanancias(sumRetiroGanancias.toLocaleString('en-US', { minimumFractionDigits: 2 }));
                setHistRetiroDisponible(sumRetiroDisponible.toLocaleString('en-US', { minimumFractionDigits: 2 }));
                setHistGananciaADisponibilidad(sumGananciaADisponibilidad.toLocaleString('en-US', { minimumFractionDigits: 2 }));

                // Total Retiros = Retiro Ganancias + Retiro Disponible
                const totalRetiros = sumRetiroGanancias + sumRetiroDisponible;
                setHistTotalRetiros(totalRetiros.toLocaleString('en-US', { minimumFractionDigits: 2 }));

                // Fecha del primer movimiento (usar primer depósito)
                setHistFechaPrimerMov(primerDeposito.fecha || "");
            }
        } catch (error) {
            console.error("Error en actResumenHistorico:", error)
        }
    }


    return (
        <>
            <Grid container justifyContent={"space-around"} rowSpacing={2} columnSpacing={1}>
                <Grid item xs={6} sm={3}>
                    <Card className="recuadros" >
                        {cargando && <Box sx={{ display: 'flex', position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
                            <CircularProgress />
                        </Box>}
                        <div className="recuadros-div-2">
                            <div className="recuadros-monto-1">
                                {disponible}
                            </div>
                            <div className="recuadros-label-1">
                                Mi Disponibilidad
                            </div>
                            <div className="recuadros-monto-2">
                                {ganancias}
                            </div>
                            <div className="recuadros-label-2">
                                Ganancias acumuladas
                            </div>
                            <div className="recuadros-icono-1">
                                <IconButton onClick={() => { props.opciones(1) }}
                                    aria-label="account of current user"
                                    aria-controls="menu-appbar"
                                    aria-haspopup="true"
                                    color="inherit"
                                >
                                    <MonetizationOnIcon />
                                </IconButton>
                            </div>
                        </div>
                    </Card>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Card className="recuadros">
                        {cargando && <Box sx={{ display: 'flex', position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
                            <CircularProgress />
                        </Box>}
                        <div className="recuadros-div-2">
                            <div className="recuadros-monto-1">
                                {transito}
                            </div>
                            <div className="recuadros-label-1">
                                {"Ganancias después del corte (" + fechaGanancia + ")"}
                            </div>
                            <div className="recuadros-monto-2">
                                {cobradoCapital}
                            </div>
                            <div className="recuadros-label-2">
                                {"Capital cobrado después del corte (" + fechaGanancia + ")"}
                            </div>

                            <div className="recuadros-icono-1">
                                <IconButton onClick={() => { props.opciones(2) }}
                                    size="large"
                                    aria-label="account of current user"
                                    aria-controls="menu-appbar"
                                    aria-haspopup="true"
                                    color="inherit"
                                >
                                    <CurrencyExchangeIcon />
                                </IconButton>
                            </div>
                        </div>
                    </Card>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Card className="recuadros" >
                        {cargando && <Box sx={{ display: 'flex', position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
                            <CircularProgress />
                        </Box>}
                        <div className="recuadros-div">
                            <div className="recuadros-monto">
                                {invertido}
                            </div>
                            <div className="recuadros-label">
                                Monto Invertido
                            </div>
                            <div className="recuadros-icono">
                                <IconButton onClick={() => { props.opciones(3) }}
                                    size="large"
                                    aria-label="account of current user"
                                    aria-controls="menu-appbar"
                                    aria-haspopup="true"
                                    color="inherit"
                                >
                                    <WalletIcon />
                                </IconButton>
                            </div>
                        </div>
                    </Card>
                </Grid>
                <Grid item xs={6} sm={3}>
                    <Card className="recuadros" >
                        {cargando && <Box sx={{ display: 'flex', position: 'absolute', left: '50%', top: '50%', transform: 'translate(-50%, -50%)' }}>
                            <CircularProgress />
                        </Box>}
                        <div className="recuadros-div-2">

                            <div className="recuadros-monto-1">
                                {clientes}
                            </div>
                            <div className="recuadros-label-1">
                                Cantidad Clientes
                            </div>
                            <div className="recuadros-monto-2" style={{ color: "red" }}>
                                {atrasados}
                            </div>
                            <div className="recuadros-label-2" style={{ color: "red" }}>
                                Atrasados
                            </div>
                            <div className="recuadros-icono-2">
                                <div>
                                    <IconButton onClick={() => { props.opciones(3) }}
                                        size="large"
                                        aria-label="account of current user"
                                        aria-controls="menu-appbar"
                                        aria-haspopup="true"
                                        color="inherit"
                                    >
                                        <PeopleIcon />
                                    </IconButton>
                                </div>
                                <div>
                                    <IconButton onClick={() => { props.opciones(4) }}
                                        size="large"
                                        aria-label="account of current user"
                                        aria-controls="menu-appbar"
                                        aria-haspopup="true"
                                        color="inherit"
                                    >
                                        <PeopleIcon />
                                    </IconButton>
                                </div>
                            </div>
                        </div>
                    </Card>
                </Grid>
            </Grid>

            {/* Resumen Histórico */}
            <Grid container sx={{ mt: 3 }}>
                <Grid item xs={12}>
                    <Paper sx={{ p: 2, borderRadius: 2, boxShadow: 3 }}>
                        <Typography variant="h6" sx={{ color: '#1e3a5f', mb: 2, borderBottom: '2px solid #d4af37', pb: 1 }}>
                            Resumen Histórico {histFechaPrimerMov && `(Desde ${histFechaPrimerMov})`}
                        </Typography>
                        <Grid container spacing={2}>
                            {/* Fila 1: Depósitos y Neto Intereses */}
                            <Grid item xs={6} sm={3}>
                                <Box sx={{
                                    textAlign: 'center',
                                    p: isMobile ? 1.5 : 2,
                                    borderRadius: 2,
                                    backgroundColor: '#e8f5e9',
                                    border: '1px solid #4caf50'
                                }}>
                                    <Typography variant={isMobile ? "body2" : "body2"} color="text.secondary" sx={{ mb: 0.5 }}>
                                        Depósitos
                                    </Typography>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                                        <AddCardIcon sx={{ fontSize: isMobile ? 20 : 40, color: '#4caf50' }} />
                                        <Typography variant={isMobile ? "body1" : "h6"} sx={{ color: '#2e7d32', fontWeight: 'bold', fontSize: isMobile ? '0.85rem' : undefined }}>
                                            RD$ {histDepositos}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <Box sx={{
                                    textAlign: 'center',
                                    p: isMobile ? 1.5 : 2,
                                    borderRadius: 2,
                                    backgroundColor: '#fff3e0',
                                    border: '1px solid #ff9800'
                                }}>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                                        Neto Intereses Cobrados
                                    </Typography>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                                        <TrendingUpIcon sx={{ fontSize: isMobile ? 20 : 40, color: '#ff9800' }} />
                                        <Typography variant={isMobile ? "body1" : "h6"} sx={{ color: '#e65100', fontWeight: 'bold', fontSize: isMobile ? '0.85rem' : undefined }}>
                                            RD$ {histNetoIntereses}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>
                            {/* Fila 2: Retiros */}
                            <Grid item xs={6} sm={3}>
                                <Box sx={{
                                    textAlign: 'center',
                                    p: isMobile ? 1.5 : 2,
                                    borderRadius: 2,
                                    backgroundColor: '#ffebee',
                                    border: '1px solid #f44336'
                                }}>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                                        Retiro Ganancias
                                    </Typography>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                                        <RemoveCircleOutlineIcon sx={{ fontSize: isMobile ? 20 : 40, color: '#f44336' }} />
                                        <Typography variant={isMobile ? "body1" : "h6"} sx={{ color: '#c62828', fontWeight: 'bold', fontSize: isMobile ? '0.85rem' : undefined }}>
                                            RD$ {histRetiroGanancias}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <Box sx={{
                                    textAlign: 'center',
                                    p: isMobile ? 1.5 : 2,
                                    borderRadius: 2,
                                    backgroundColor: '#fce4ec',
                                    border: '1px solid #e91e63'
                                }}>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                                        Retiro Disponible
                                    </Typography>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                                        <PaymentsIcon sx={{ fontSize: isMobile ? 20 : 40, color: '#e91e63' }} />
                                        <Typography variant={isMobile ? "body1" : "h6"} sx={{ color: '#ad1457', fontWeight: 'bold', fontSize: isMobile ? '0.85rem' : undefined }}>
                                            RD$ {histRetiroDisponible}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                        {/* Fila 3: Ganancia a Disponibilidad, Total Retiros, Monto Atrasados, Clientes Al Día */}
                        <Grid container spacing={2} sx={{ mt: 1 }}>
                            <Grid item xs={6} sm={3}>
                                <Box sx={{
                                    textAlign: 'center',
                                    p: isMobile ? 1.5 : 2,
                                    borderRadius: 2,
                                    backgroundColor: '#e3f2fd',
                                    border: '1px solid #2196f3'
                                }}>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                                        Ganancia a Disponibilidad
                                    </Typography>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                                        <SwapHorizIcon sx={{ fontSize: isMobile ? 20 : 40, color: '#2196f3' }} />
                                        <Typography variant={isMobile ? "body1" : "h6"} sx={{ color: '#1565c0', fontWeight: 'bold', fontSize: isMobile ? '0.85rem' : undefined }}>
                                            RD$ {histGananciaADisponibilidad}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <Box sx={{
                                    textAlign: 'center',
                                    p: isMobile ? 1.5 : 2,
                                    borderRadius: 2,
                                    backgroundColor: '#fce4ec',
                                    border: '2px solid #e91e63'
                                }}>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                                        Total Retiros
                                    </Typography>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                                        <PaymentsIcon sx={{ fontSize: isMobile ? 20 : 40, color: '#e91e63' }} />
                                        <Typography variant={isMobile ? "body1" : "h6"} sx={{ color: '#c2185b', fontWeight: 'bold', fontSize: isMobile ? '0.85rem' : undefined }}>
                                            RD$ {histTotalRetiros}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <Box sx={{
                                    textAlign: 'center',
                                    p: isMobile ? 1.5 : 2,
                                    borderRadius: 2,
                                    backgroundColor: '#fff8e1',
                                    border: '2px solid #ff8f00'
                                }}>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                                        Monto Atrasados
                                    </Typography>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                                        <WarningAmberIcon sx={{ fontSize: isMobile ? 20 : 40, color: '#ff8f00' }} />
                                        <Typography variant={isMobile ? "body1" : "h6"} sx={{ color: '#e65100', fontWeight: 'bold', fontSize: isMobile ? '0.85rem' : undefined }}>
                                            RD$ {montoAtrasados}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>
                            <Grid item xs={6} sm={3}>
                                <Box sx={{
                                    textAlign: 'center',
                                    p: isMobile ? 1.5 : 2,
                                    borderRadius: 2,
                                    backgroundColor: '#e8f5e9',
                                    border: '2px solid #4caf50'
                                }}>
                                    <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
                                        Clientes Al Día
                                    </Typography>
                                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 0.5 }}>
                                        <CheckCircleIcon sx={{ fontSize: isMobile ? 20 : 40, color: '#4caf50' }} />
                                        <Typography variant={isMobile ? "body1" : "h6"} sx={{ color: '#2e7d32', fontWeight: 'bold', fontSize: isMobile ? '0.85rem' : undefined }}>
                                            RD$ {montoClientesAlDia}
                                        </Typography>
                                    </Box>
                                </Box>
                            </Grid>
                        </Grid>
                    </Paper>
                </Grid>
            </Grid>

            {/* Gráfico de Movimientos */}
            <Grid container sx={{ mt: 3 }}>
                <Grid item xs={12}>
                    <Paper sx={{ p: isMobile ? 1.5 : 2, borderRadius: 2, boxShadow: 3 }}>
                        <Box sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            mb: 2,
                            borderBottom: '2px solid #d4af37',
                            pb: 1
                        }}>
                            <Typography variant={isMobile ? "body1" : "h6"} sx={{ color: '#1e3a5f', fontWeight: 600 }}>
                                Movimientos del Mes
                            </Typography>
                        </Box>
                        {chartData.series[0].data.length > 0 ? (
                            <>
                                <ReactApexChart
                                    options={{
                                        ...chartData.options,
                                        chart: {
                                            ...chartData.options.chart,
                                            height: isMobile ? 250 : 350,
                                            toolbar: {
                                                show: true,
                                                offsetX: 0,
                                                offsetY: isMobile ? -40 : 0,
                                                tools: {
                                                    download: true,
                                                    selection: false,
                                                    zoom: !isMobile,
                                                    zoomin: true,
                                                    zoomout: true,
                                                    pan: false,
                                                    reset: true
                                                },
                                            },
                                        },
                                        title: {
                                            ...chartData.options.title,
                                            text: '',
                                        }
                                    }}
                                    series={chartData.series}
                                    type="area"
                                    height={isMobile ? 250 : 350}
                                />
                                {/* Sumatorias del gráfico */}
                                <Box sx={{
                                    display: 'flex',
                                    justifyContent: 'space-around',
                                    mt: isMobile ? 1 : 2,
                                    pt: isMobile ? 1 : 2,
                                    borderTop: '1px solid #e0e0e0',
                                    flexWrap: 'wrap',
                                    gap: isMobile ? 1 : 2
                                }}>
                                    <Box sx={{ textAlign: 'center', minWidth: isMobile ? 100 : 150 }}>
                                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: isMobile ? '0.75rem' : undefined }}>
                                            Total Disponible
                                        </Typography>
                                        <Typography variant={isMobile ? "body1" : "h6"} sx={{ color: '#1e3a5f', fontWeight: 'bold', fontSize: isMobile ? '0.85rem' : undefined }}>
                                            RD$ {totalDisponible.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ textAlign: 'center', minWidth: isMobile ? 100 : 150 }}>
                                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: isMobile ? '0.75rem' : undefined }}>
                                            Total Ganancias
                                        </Typography>
                                        <Typography variant={isMobile ? "body1" : "h6"} sx={{ color: '#d4af37', fontWeight: 'bold', fontSize: isMobile ? '0.85rem' : undefined }}>
                                            RD$ {totalGanancias.toLocaleString('en-US', { minimumFractionDigits: 2 })}
                                        </Typography>
                                    </Box>
                                    <Box sx={{ textAlign: 'center', minWidth: isMobile ? 100 : 150 }}>
                                        <Typography variant="body2" color="text.secondary" sx={{ fontSize: isMobile ? '0.75rem' : undefined }}>
                                            Cantidad de Movimientos
                                        </Typography>
                                        <Typography variant={isMobile ? "body1" : "h6"} sx={{ color: '#1e3a5f', fontWeight: 'bold', fontSize: isMobile ? '0.85rem' : undefined }}>
                                            {cantidadMovimientos}
                                        </Typography>
                                    </Box>
                                </Box>
                            </>
                        ) : (
                            <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: 200 }}>
                                <Typography color="text.secondary">
                                    {cargando ? 'Cargando datos...' : 'No hay movimientos en este período'}
                                </Typography>
                            </Box>
                        )}
                    </Paper>
                </Grid>
            </Grid>
        </>
    )
}
